import { boundMethod } from 'autobind-decorator';
import { config } from 'lib-shared-backend-config';
import { ChangeEvent, Component } from 'react';

import { PrivateMediaPlayer } from 'components/privateMediaPlayer';
import type { AudioT } from 'components/shared/audio/api/types';

import type { PropsT as WaitMusicWithPlayerPropsT } from '../../waitMusic/components/WaitMusicWithPlayer';

export class BrowserTab extends Component<WaitMusicWithPlayerPropsT> {
  UNSAFE_componentWillReceiveProps(nextProps: WaitMusicWithPlayerPropsT) {
    if (
      nextProps.selectedAudio.id &&
      nextProps.selectedAudio.id !== this.props.selectedAudio.id
    ) {
      this.props.waitMusicSelect({ selectedAudio: nextProps.selectedAudio });
      this.props.onSelectedCallback({ selectedAudio: nextProps.selectedAudio });
    }
  }

  componentDidMount() {
    if (this.props.selectedAudio.id) {
      this.props.onSelectedCallback({
        selectedAudio: this.props.selectedAudio,
      });
    }
  }

  @boundMethod
  selectAudio(audioId: undefined | null | string = null): void {
    if (audioId) {
      const foundAudio = this.props.allAudios.find((a) => a.id === audioId);
      if (foundAudio) {
        this.props.waitMusicSelect({ selectedAudio: foundAudio });
        this.props.onSelectedCallback({ selectedAudio: foundAudio });
      } else {
        console.warn('foundAudio', foundAudio);
      }
    }
  }

  @boundMethod
  getMediaUrl(): string {
    const { selectedAudio } = this.props;

    return selectedAudio && selectedAudio.master_file_path
      ? `${config.url.files}${selectedAudio.master_file_path}`
      : '';
  }

  render() {
    const audioOptions: AudioT[] = [];
    const src = this.getMediaUrl();
    let disabled = true;
    let validateText =
      this.props.labelError !== undefined && this.props.labelError !== null ? (
        <span className="validation-text text-capitalize">
          {this.props.labelError}
        </span>
      ) : null;

    if (this.props.meta.getAsyncStatus === 'loading') {
      validateText = (
        <span className="validation-text text-capitalize">
          Fetching please wait..
        </span>
      );
    } else if (this.props.meta.uploadAsyncStatus === 'loading') {
      validateText = (
        <span className="validation-text text-capitalize">
          Uploading please wait..
        </span>
      );
    } else if (this.props.meta.getAsyncStatus === 'succeeded') {
      if (this.props.allAudios.length > 0) {
        //validateText = <span className="validation-text text-capitalize ">Select a wait music file</span>
      } else {
        validateText = (
          <span className="validation-text text-capitalize">
            You need to upload a music file first - click &quot;+Add new&quot;
          </span>
        );
      }
      disabled = false;
    }

    for (const audio of this.props.allAudios) {
      audioOptions.push({
        ...audio,
        chunk_duration_in_secs: 30,
      });
    }

    return (
      <div>
        <div
          className={
            'form-group form-group-select ' +
            (disabled ? 'disabled' : '') +
            (this.props.className ?? '')
          }
        >
          <label className="control-label" htmlFor="holdMusicSelect">
            Select audio {validateText}
          </label>
          <select
            id="audio-browser"
            className="form-control"
            name="audio-browser"
            value={this.props.selectedAudio?.id ?? ''}
            onChange={(e: ChangeEvent<HTMLSelectElement>) =>
              this.selectAudio(e.target.value)
            }
            disabled={disabled}
          >
            <option value="" hidden={!this.props.optional}>
              {' '}
              -{' '}
              {this.props.meta.getAsyncStatus === 'loading'
                ? 'Loading...'
                : 'No audio selected'}
            </option>
            {audioOptions.map((audio: AudioT) => (
              <option key={audio.id} value={audio.id}>
                {audio.name}
              </option>
            ))}
          </select>
        </div>
        <PrivateMediaPlayer
          filename={this.props.selectedAudio.name}
          mediaFile={{ src, type: 'audio' }}
        />
      </div>
    );
  }
}
